import Vue from 'vue'
import App from './App.vue'

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import store from './store/index'
import './api/mock'
Vue.use(ElementUI)

Vue.config.productionTip = false
import router from './router/index';
new Vue({
  created(){
    store.commit("addMenu",router)
  },

  store,
  render: h => h(App),
  router:router
}).$mount('#app')
